<template>
    <b-modal
        :id="modalId"
        :init="init"
        size="xl"
        modal-class="form-modal"
        @show="onShow"
        @shown="onShown"
        @close="onClose"
        >
        <template slot="modal-title">
            <fieldset
                :disabled="auth_level < '100'"
                style="font-size: 1rem"
                >
                <slot :error="error" name="modal-title">
                {{ model.id ? '#' + model.id : '新規' }}
                </slot>
            </fieldset>
        </template>
    
        <fieldset :disabled="auth_level < '100'">
            <slot :error="error" name="form"></slot>
        </fieldset>
    
        <template slot="modal-footer">
            <template v-if="auth_level < '100'"></template>
            <template v-else>
                <template v-if="model.id">
                    <b-form-radio-group
                        v-model="is_edit_mode"
                        :options="[
                            { text: '詳細', value: false },
                            { text: '編集', value: true },
                        ]"
                        buttons
                        button-variant="outline-secondary"
                        size="sm"
                        class="mr-auto"
                    ></b-form-radio-group>
                </template>
    
                <template v-if="is_edit_mode">
                    <b-button-group>
                        <b-dropdown variant="outline-secondary" size="sm" text="他">
                            <b-dropdown-item href="#" variant="danger" @click="destroy">削除</b-dropdown-item>
                        </b-dropdown>
    
                        <b-button size="sm" variant="primary" @click="save">
                            保存
                        </b-button>
                    </b-button-group>
                </template>
            </template>
        </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {},
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        modalId: {
            type: String,
            required: true,
            default() {
                return 'modal'
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
        show: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        const upper = this.modalId.charAt(0).toUpperCase() + this.modalId.slice(1)
        return {
            error: {},
            action: {
                save: this.modalId + '/save',
                destroy: this.modalId + '/destroy',
//                save: this.modalId + '/save' + upper,
//                destroy: this.modalId + '/destroy' + upper,
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_level',
        ]),
        is_edit_mode: {
            get() {
                return Boolean(this.model.is_edit_mode)
            },
            set(value) {
                this.$set(this.model, 'is_edit_mode', value)
                if (!value) {
                    this.init(this.model)
                }
            },
        },
    },
    mounted() {},
    methods: {
        onShow(event) {
            this.reset(event)
            this.$emit('show')
        },
        onShown(event) {
            this.$emit('shown')
            this.$set(this.model, 'is_edit_mode', Boolean(!this.model.id))
        },
        onClose(event) {
            this.$emit('close')
        },
        reset(event) {
            this.error = {}
        },
        save(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            this.error = {}
            this.$store
                .dispatch(this.action.save, this.model)
                .then((response) => {
                    this.$bvModal.hide(this.modalId)
                    this.$bus.$emit('form-modal:save-callback', response)
                })
                .catch((error) => {
                    this.error = error
                })
        },
        destroy(event) {
            if (event instanceof Event) {
                event.preventDefault()
            }
            if (!confirm('本当に削除しますか？')) {
                return
            }
            this.error = {}
            this.$store
                .dispatch(this.action.destroy, this.model)
                .then((response) => {
                    this.$bvModal.hide(this.modalId)
                    this.$bus.$emit('form-modal:destroy-callback', response)
                })
                .catch((error) => {
                    this.error = error
                })
        },
    },
}
</script>

<style lang="scss" scoped>
</style>


